// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Auth_pageWrapper__3Z5Hq"};